import React from 'react';

const RoleManagement = ({ roles, updateRolesData }) => {
    return (
        <div className="roles-container">
            {roles.map((user) => (
                <div key={user.email} className="roles-user-block">
                    <h3>{user.email}</h3>
                    <div className="roles-grid">
                        <button
                            className="add-button"
                            onClick={() => {
                                const newRole = prompt("Enter new role name:");
                                if (newRole && !user.roles[newRole]) {
                                    const updatedRoles = { ...user.roles, [newRole]: { actions: [], pages: [] } };
                                    updateRolesData(user.email, updatedRoles);
                                } else if (user.roles[newRole]) {
                                    alert("Role already exists!");
                                }
                            }}
                        >
                            + Add New Role
                        </button>
                        {Object.entries(user.roles || {}).map(([roleKey, roleData]) => (
                            <div key={roleKey} className="role-section pretty-role-section">
                                <div className="role-header">
                                    <div className="role-chip">{roleKey}</div>
                                    <button
                                        className="edit-button"
                                        onClick={() => {
                                            const newRoleName = prompt("Edit role name:", roleKey);
                                            if (newRoleName && newRoleName !== roleKey) {
                                                const updatedRoles = { ...user.roles };
                                                updatedRoles[newRoleName] = updatedRoles[roleKey];
                                                delete updatedRoles[roleKey];
                                                updateRolesData(user.email, updatedRoles);
                                            }
                                        }}
                                    >
                                        Edit
                                    </button>
                                    <button
                                        className="delete-button"
                                        onClick={() => {
                                            if (window.confirm(`Delete role "${roleKey}"?`)) {
                                                const updatedRoles = { ...user.roles };
                                                delete updatedRoles[roleKey];
                                                updateRolesData(user.email, updatedRoles);
                                            }
                                        }}
                                    >
                                        ×
                                    </button>
                                </div>
                                <div className="section-header">
                                    <h6>Actions</h6>
                                    <button
                                        className="add-button"
                                        onClick={() => {
                                            const newAction = prompt("Enter new action (e.g., GET /path):");
                                            if (newAction) {
                                                const updatedRoles = { ...user.roles };
                                                updatedRoles[roleKey] = {
                                                    ...updatedRoles[roleKey],
                                                    actions: [...(roleData.actions || []), newAction]
                                                };
                                                updateRolesData(user.email, updatedRoles);
                                            }
                                        }}
                                    >
                                        + Add Action
                                    </button>
                                </div>
                                <div className="actions-grid">
                                    {roleData.actions?.map((action, actionIdx) => (
                                        <div key={actionIdx} className="action-chip">
                                            {action}
                                            <button
                                                className="delete-button"
                                                onClick={() => {
                                                    const updatedRoles = { ...user.roles };
                                                    updatedRoles[roleKey] = {
                                                        ...updatedRoles[roleKey],
                                                        actions: roleData.actions.filter((_, idx) => idx !== actionIdx)
                                                    };
                                                    updateRolesData(user.email, updatedRoles);
                                                }}
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}
                                </div>
                                <div className="section-header">
                                    <h6>Pages</h6>
                                    <button
                                        className="add-button"
                                        onClick={() => {
                                            const newPage = prompt("Enter new page path:");
                                            if (newPage) {
                                                const updatedRoles = { ...user.roles };
                                                updatedRoles[roleKey] = {
                                                    ...updatedRoles[roleKey],
                                                    pages: [...(roleData.pages || []), newPage]
                                                };
                                                updateRolesData(user.email, updatedRoles);
                                            }
                                        }}
                                    >
                                        + Add Page
                                    </button>
                                </div>
                                <div className="pages-grid">
                                    {roleData.pages?.map((page, pageIdx) => (
                                        <div key={pageIdx} className="page-chip">
                                            {page}
                                            <button
                                                className="delete-button"
                                                onClick={() => {
                                                    const updatedRoles = { ...user.roles };
                                                    updatedRoles[roleKey] = {
                                                        ...updatedRoles[roleKey],
                                                        pages: roleData.pages.filter((_, idx) => idx !== pageIdx)
                                                    };
                                                    updateRolesData(user.email, updatedRoles);
                                                }}
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default RoleManagement; 